import Link from '@Components/common/Link';
import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`;

export const Header = styled.div`
  padding: 22px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
`;

export const Title = styled.h6`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h6};
`;

export const Cta = styled(Link)`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const Content = styled.div`
  padding: 24px 18px;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 366px;
`;

export const Footer = styled.div`
  padding-top: 18px;
  border-top: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
`;

export const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 26px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Item = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
`;

export const Price = styled(Item)`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
`;

export const Total = styled.h6`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h6};
`;

export const TotalPrice = styled(Total)``;
